import React from 'react';
import LocalIcon from './LocalIcon';

const Icon = ({ name, className = '' }) => {
  return (
    <LocalIcon 
      icon={name}
      className={className}
    />
  );
};

export default Icon; 